import React, { useEffect } from 'react'
import Auth from './Components/Auth'
import Container from './Components/Container'
import Footer from './Components/Footer'
import Header from './Components/Header'
import UserInput from './Components/UserInput'

const preventKeyboardShortcuts = (event) => {
  if (event.keyCode === 123) {
    event.preventDefault();
  }
  if (event.ctrlKey && event.shiftKey && event.keyCode === 'I'.charCodeAt(0)) {
    event.preventDefault();
  }
  if (event.ctrlKey && event.shiftKey && event.keyCode === 'J'.charCodeAt(0)) {
    event.preventDefault();
  }
  if (event.ctrlKey && event.keyCode === 'U'.charCodeAt(0)) {
    event.preventDefault();
  }
};

const preventRightClick = (event) => {
  event.preventDefault();
};

const App = () => {
  useEffect(() => {
    document.addEventListener('keydown', preventKeyboardShortcuts, false);
    document.addEventListener('contextmenu', preventRightClick, false)
    return () => {
      document.removeEventListener('keydown', preventKeyboardShortcuts, false);
      document.removeEventListener('contextmenu', preventRightClick, false)
    };
  }, []);

  const user = JSON.parse(localStorage.getItem('aa-auth'))

  return <>
    <Header />
    {
      user ? <UserInput /> : (
         <section id="user_input" className="bg-slate-600 w-full py-4 px-2 text-center align-middle">
          <h4 className='nes-text is-disabled'>Sign In to throw your links...</h4>
         </section>
      )
    }
    <Container />

    <Footer />
  </>
}

export default App